<template>
  <div class="over">
    <div class="evaluation">
      运营信息
    </div>
    <div class="statistics row-center">
        <div class="item">
            <div class="name">今日充电量(kWh)</div>
            <div class="num">160</div>
        </div>
        <div class="item">
            <div class="name">电池剩余电量(%)</div>
            <div class="num">100</div>
        </div>
        <div class="item">
            <div class="name">运行状态</div>
            <div class="num">正常</div>
        </div>
        <div class="item">
            <div class="name">今日放电量(kWh)</div>
            <div class="num">0</div>
        </div>
        <div class="item">
            <div class="name">电池健康度(%)</div>
            <div class="num">99</div>
        </div>
        <div class="item">
            <div class="name">电池容量</div>
            <div class="num">200kWh</div>
        </div>
    </div>
    <div class="evaluation">
      变流器概况
    </div>
    <div class="bianlq">
      <span class="active">变流器1</span>
      <span>变流器2</span>
    </div>
    <div class="looptable">
      
      <!-- height="22vh" -->
      <el-table
          row-class-name="rowName"
          header-row-class-name="headerName"
          border
          :data="tableData"
          stripe
          style="width: 100%">
          <el-table-column
          width="120"
          class-name="name"
          prop="name"
          label=""
          align="center">
          </el-table-column>
          <el-table-column
          prop="val1"
          align="center"
          label="A相">
          </el-table-column>
          <el-table-column
          prop="val2"
          align="center"
          label="B相">
          </el-table-column>
          <el-table-column
          prop="val2"
          align="center"
          label="C相">
          </el-table-column>
          <el-table-column
          prop="total"
          align="center"
          label="总">
          </el-table-column>
      </el-table>
  </div>
    <!-- <div class="rate"> -->
      <!-- <img src="../../../assets/img/cnimg.png" alt=""> -->
    <!-- </div> -->
  </div>
</template>

<script>

export default {
  data() {
    return {
      tableData: [{
          name: '电网侧电流(A)',
          val1: '242.72',
          val2: '242.75',
          total:'--'
      }, {
          name: '电网侧电压(V)',
          val1: '412.5',
          val2: '412.3',
          total:'--'
      }, {
          name: '直流侧电流(A)',
          val1: '--',
          val2: '--',
          total:'138.8'
      }, {
          name: '直流侧电压(V)',
          val1: '--',
          val2: '--',
          total:'720'
      }],
      list: [
        {
          id: 0,
          isFree: false,
          color: '#f6bd16'
        }, {
          id: 1,
          isFree: false,
          color: '#f6bd16'
        }, {
          id: 2,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 3,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 4,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 5,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 6,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 7,
          isFree: true,
          color: '#01ab65'
        }, {
          id: 8,
          isFree: true,
          color: '#01ab65'
        },
      ]
    }
  },

  mounted() {
  },
  methods: {
    handleCounts(flag) {
      return this.list.filter(item => {
        return item.isFree === flag
      }).length
    }
  }
}
</script>

<style lang="less" scoped>

/deep/ .looptable{
    table{
        width: 100%;
        td{
            height: 40rem;
            text-align: center;
            font-size: 16rem;
            width: 20%;
        }
        // tr:nth-child(odd){
        //     background: rgba(0, 43, 102, 0.03);
        // }
        // tr td:nth-child(even){

        //     background: rgba(0, 43, 102, 0.03);
        // }
        .name{
            // color: #0D94FF;
        }
    }
}

/deep/.headerName{
    th{
        // background: rgba(0, 43, 102, 0.03);
        border-bottom: 0;
        font-size: 16rem;
        color: #333;
        font-weight: 400;
        height: 4vh;
        padding: 0;
    }
}
/deep/.rowName{
    td{
        border-bottom: 0;
        font-size: 16rem;
        color: #0D94FF;
        font-weight: 400;
        height: 4vh;
        background: none !important;
        padding: 0;
    }
    .name{
        color: #333;

    }
    // td:nth-child(even){
    //     background: rgba(0, 43, 102, 0.03) !important;
    // }
}
/deep/.headerName {
    background-color: rgba(0, 43, 102, 0.03) !important;
    th{
        background: none;
    }
    // th:nth-child(even){
    //     background: rgba(0, 43, 102, 0.03) !important;
    // }
}
/deep/.el-table__row--striped.rowName{
    background: rgba(0, 43, 102, 0.03);
}
/deep/.el-table--border::after, /deep/.el-table--group::after, /deep/.el-table::before{
    content: none;
}
/deep/.el-table--border,/deep/ .el-table--group{
    border: 0;
}

.bianlq{
  text-align: right;
  span{
    display: inline-block;
    line-height: 30px;
    margin-left: 20px;
    font-size: 15px;
    cursor: pointer;
  }
  .active{
    border-top: 2px solid #0D94FF;
    color: #0D94FF;
  }
}

  .statistics{
      justify-content: space-between;
      .item{
          background: rgba(0, 43, 102, 0.03);
          width: 32.5%;
          height: 8.2vh;
          text-align: left;
          margin-bottom: 8rem;
          border-radius: 6rem;
          padding-left: 24px;
          .name{
              font-size: 16rem;
              margin-top: 1.5vh;
          }
          .num{
              font-size: 26rem;
              font-weight: bold;
              color: #0D94FF;
          }
          span{
              font-size: 20rem;
              margin-left: 3rem
          }
      }
  }
.case{

}
.over {
  .evaluation {
    height: 3.2vh;
    padding-top: 7rem;
    padding-left: 13rem;
    line-height: 28rem;
    box-sizing: border-box;
    font-size: 16rem;
    font-weight: 400;
    color: #333333;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    &::before {
      content: '';
      width: 5rem;
      height: 18rem;
      background: #0D94FF;
      position: absolute;
      left: 0;
      top: 12.5rem;
    }
  }

  .rate {
    height: 200px;
    img{
      // width: 100%;
      height: 100%;
    }
    
  }

  .info {
    // height: 31.5vh;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.15);

  }
}
</style>